import React, { forwardRef, type ForwardedRef } from "react";
import type { KeyboardDatePickerProps } from "@material-ui/pickers";
import ZonedKeyboardDatePicker from "src/components/ZonedKeyboardDatePicker";

interface DateInputProps {
  value?: Date;
  loading: boolean;
  onChange: (e: React.ChangeEvent<any>, t?: any) => void;
}

export const DateInput = forwardRef(
  (
    {
      value,
      onChange,
      loading,
      ...props
    }: DateInputProps & Partial<Omit<KeyboardDatePickerProps, "onChange">>,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <ZonedKeyboardDatePicker
        ref={ref}
        disableToolbar
        className="w-full"
        variant="inline"
        format="MM/dd/yyyy"
        margin="dense"
        label="Date"
        required
        autoOk={true}
        value={value || null}
        disabled={loading}
        onChange={(d) => {
          onChange({
            target: { value: d || null },
          } as unknown as React.ChangeEvent<Date>);
        }}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        inputVariant="outlined"
        {...props}
      />
    );
  }
);
